import reducer from './reducers'
import api from './api'

const name = 'notifications'

export { name, api, reducer }
